import type { S3ObjectResourceType } from '@mbfab/shared'

// 統一アップロード画面(Step1)で選択できるファイル種別。
// 従来は「ミルシートのアップロード画面」「加工証明のアップロード画面」と画面が分かれており、
// 「剪断証明書の画面からミルシートをアップロードできない」といった分かりづらさがあった。
// そのため種別選択を1画面に集約する（v1 apps/frontend/client/src/components/upload/uploadFileType.ts の移植）。
// なお millsheetAttachments(添付資料) は本統一UIの主対象ではないため、あえて選択肢には含めない。
export type UploadFileType = Extract<S3ObjectResourceType, 'millsheets' | 'shearingCertificates' | 'nestingDiagrams'>

export type UploadFileTypeOption = {
  resourceType: UploadFileType
  label: string
  // Step1/Step2 で表示する、種別ごとの紐付けルールの説明。
  description: string
}

export const uploadFileTypeOptions: UploadFileTypeOption[] = [
  {
    resourceType: 'millsheets',
    label: 'ミルシート',
    description:
      'ファイル名を「証明書番号_工事名称_注文番号」にすると、対象のミルシートへ自動で紐付きます。' +
      '注文番号を省略して「証明書番号_工事名称」にした場合も、該当ミルシートが1件のときは紐付きます' +
      '（同じ証明書番号・工事名称が注文番号ごとに複数行あるときは、注文番号まで付けてください）。' +
      '工事名称も省略して「証明書番号」のみにした場合は、確認ダイアログでOKするとアップロードでき、' +
      '該当ミルシートが1件のときだけ紐付きます（同じ証明書番号が複数の工事にある場合は、確認欄から手動で紐付けてください）。',
  },
  {
    resourceType: 'shearingCertificates',
    label: '剪断証明書',
    description: 'ファイル名を「剪断証明書番号」にすると、対象の剪断証明書へ自動で紐付きます。',
  },
  {
    resourceType: 'nestingDiagrams',
    label: 'ネスティング図',
    description:
      'ファイル名が「個体番号」の初期値になり、アップロードだけでレコードが作成されます。個体番号が一致する剪断証明書へ自動で紐付きます。',
  },
]
